import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function tableDetailFetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATISTIC_TABLE_FETCHING:
      return true;
    case actions.SET_STATISTIC_TABLE:
    case actions.SET_STATISTIC_ERROR:
      return false;
    default:
      return state;
  }
}
